import { hostedStyles, hostedTrafficStyles } from '../../endpoints';
import sessionId from '../../configurer/sessionId';

const vectorStyleResolverFactory = (stylesEndpoint) => {
    return (options) => {
        const { layer, style, version } = options.unwrapedTheme;
        const key = options.key;

        return stylesEndpoint
            .replace('{themeLayer}', layer)
            .replace('{themeStyle}', style)
            .replace('{version}', version)
            .replace('{key}', key)
            .replace('{sessionId}', sessionId.getInstance().get());
    };
};

export const vectorMapStyleResolver = vectorStyleResolverFactory(hostedStyles);
export const vectorTrafficTilesResolver = vectorStyleResolverFactory(hostedTrafficStyles);



// WEBPACK FOOTER //
// ./map/tier/styleParts/vectorStyleResolver.js